import { Area } from "Models/Areas/Area";
import { RoleType } from "Models/Users/RoleType";
import { ChecklistItemTemplate } from "./ChecklistItemTemplate";

export class ChecklistTemplate {
    public id?: number;
    public name: string;
    public description: string;
    public pictureUrl?: string;
    public area: Area;
    public role: RoleType = RoleType.basic;
    public signatureRequired: boolean = false;
    public doubleSignatureRequired: boolean = false;
    public items: ChecklistItemTemplate[] = [];
    public totalInstructionCount: number = 0;
    public createdAt: Date;
    public lastUpdatedAt: Date;
}


// WEBPACK FOOTER //
// ./src/Models/Checklists/ChecklistTemplate.ts